import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import ManyTags from '../../components/Table/components/ColumnRender/components/CellRender/Type/ManyTags'
import { Tag } from '../../components/Table/components/ColumnRender/components/CellRender/Type/Tag'

export default function ManyTagsPortal() {
  const [elements, setElements] = useState<Element[]>([])

  useEffect(() => {
    setElements(Array.from(document.querySelectorAll('.tags_list')))
  }, [])

  return <>{
    elements.map(element => {
      const tags = element.getAttribute('data-tags')
      return createPortal(<ManyTags tags={tags !== null ? JSON.parse(tags) as unknown as Tag[] : []} />, element)
    })
  }</>
}
